import { Box } from "@mui/material";
import { FilterDropdown } from "../../molecules/FilterDropdown";
import { useTemplateContext } from "./TemplateContext";
import { useEffect } from "react";

const templateTypes = [
  { text: "Suregifts Templates", value: false },
  { text: "Saved Templates", value: true },
];
export const TemplateClientTypeView = () => {
  const { changeClientType, state, apiTemplates } = useTemplateContext();
  useEffect(() => {
    if (!apiTemplates) return;
    if (!state.isAdmin) {
      var useClientType = apiTemplates!.savedTemplates.length > 0;
      changeClientType(useClientType);
    }
  }, [apiTemplates]);
  if (apiTemplates?.savedTemplates.length === 0) return <div></div>;
  return (
    <Box>
      <FilterDropdown onChange={(index, value) => changeClientType(value)} value={state.isClientType} fullWidth variant="contained" color="primary" display="Select Template" options={templateTypes} />
    </Box>
  );
};
